<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="masterList.tableQuery.name"
              placeholder="请输入名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="masterList.tableQuery.phone"
              placeholder="请输入电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @stop="stopFun(arguments)"
        @start="startFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 修改 查看-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditViewTitle"
      :dialog-visible.sync="dialogAddEditViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增 修改
import addEditViewDialog from './components/addEditViewDialog'
// 外聘人员API
import { loadExternalEmployeeListDataApi, exportExternalEmployeeListDataApi, updateStatusExternalEmployeeApi } from '@/api/v2/externalEmployee';

export default {
  name: 'ExternalEmployee',
  components: {
    CustomTable2,
    TableOperation2,
    addEditViewDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'external_employee_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['external_employee_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['external_employee_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['external_employee_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['external_employee_start'],
            prop: 'start',
            label: '启用',
            method: 'start'
          },
          {
            permissionSigns: ['external_employee_stop'],
            prop: 'stop',
            label: '停用',
            method: 'stop'
          },
          {
            permissionSigns: ['external_employee_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          name: '',
          phone: ''
        }
      },
      // 选中的数据ID
      id: null,
      eventType: '',
      dialogAddEditViewTitle: '',
      dialogAddEditViewVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', filterColumn: 'province_name', label: '省区', width: 120 },
      { prop: 'cityName', filterColumn: 'city_name', label: '城市', width: 120 },
      { prop: 'name', label: '名称', width: 100 },
      { prop: 'phone', label: '电话', width: 120 },
      { prop: 'typeValue', filterColumn: 'type', filterValue: 'type', label: '人员类型', width: 110, filterArray: [{ label: '礼仪', value: 1 }, { label: '主持人', value: 2 }] },
      { prop: 'sortValue', filterColumn: 'sort', filterValue: 'sort', label: '人员类别', width: 110, filterArray: [{ label: '直聘', value: 1 }, { label: '三方公司', value: 2 }] },
      { prop: 'sexValue', filterColumn: 'sex', filterValue: 'sex', label: '性别', width: 110, filterArray: [{ label: '男', value: 1 }, { label: '女', value: 2 }] },
      { prop: 'idCard', label: '身份证号', filterColumn: 'id_card', width: 200 },
      { prop: 'idEndDate', filterColumn: 'id_end_date', label: '身份证有效截止日期', width: 180, isBetween: true },
      { prop: 'bankName', label: '开户行', filterColumn: 'bank_name', width: 160 },
      { prop: 'bankNo', label: '银行账号', filterColumn: 'bank_no', width: 160 },
      { prop: 'statusValue', filterColumn: 'status', filterValue: 'status', label: '状态', width: 80, filterArray: [{ label: '启用', value: 1 }, { label: '停用', value: 2 }] },
      { prop: 'remark', label: '备注' },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 100 },
      { prop: 'operationTimeStr', filterColumn: 'operation_time', label: '操作时间', width: 150, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadExternalEmployeeListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response;
        this.handleData(data.list || [])
        this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 新增
    addFun () {
      let _this = this;
      _this.eventType = 'add'
      _this.dialogAddEditViewTitle = '新增外聘人员'
      _this.dialogAddEditViewVisible = !_this.dialogAddEditViewVisible
    },
    // 修改
    editFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的外聘人员', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogAddEditViewTitle = '修改外聘人员'
      _this.dialogAddEditViewVisible = !_this.dialogAddEditViewVisible
    },
    // 查看
    viewFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的外聘人员', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogAddEditViewTitle = '查看外聘人员'
      _this.dialogAddEditViewVisible = !_this.dialogAddEditViewVisible
    },
    // 停用
    stopFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要停用的外聘人员', type: 'warning' })
        return
      }
      _this.$confirm('是否确定停用该外聘人员？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateStatusExternalEmployeeApi({ id: args[0].id, status: 2 }).then(() => {
          _this.$message({ message: '停用成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 启用
    startFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要启用的外聘人员', type: 'warning' })
        return
      }
      _this.$confirm('是否确定启用该外聘人员？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateStatusExternalEmployeeApi({ id: args[0].id, status: 1 }).then(() => {
          _this.$message({ message: '启用成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportExternalEmployeeListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
